import React from 'react';
import PropTypes from 'prop-types';
import './CurrencyMenuItem.less';
import {SVGIcon} from '@homeaway/react-svg';
import {CHECK__16} from '@homeaway/svg-defs';

/**
 * CurrencyMenuItem
 *
 * This component is used to render a single menu item
 * @prop {*} currencyCode : code of the currency to be rendered
 * @prop {*} currencyName : name of the currency to be rendered
 * @prop {*} currencySymbol : symbol of the currency to be rendered
 * @prop {*} isActive : boolean to indicate whether the given currency
 * is the selected currency on the site
 */
function CurrencyMenuItem(props) {
    let handleMenuItemClick = function() {
        props.eventTrigger(props.currencyCode);
    };
    return (
        <div
            className="CurrencyMenuItem"
            role={'menuitem'}
            onClick={handleMenuItemClick}
        >   
            {props.isActive &&
                <SVGIcon className="CurrencyMenuItem__check" inline markup={CHECK__16} />
            }
            <div>
                <span className="CurrencyMenuItem__currency-code">{props.currencyCode}</span>
                <span className="CurrencyMenuItem__currency-name">{props.currencyName}</span>
                <span className="CurrencyMenuItem__currency-symbol">({props.currencySymbol})</span>
            </div>
        </div>
    );
}
CurrencyMenuItem.propTypes = {
    /** Available currency option */
    currencyCode: PropTypes.string.isRequired,
    /** Currency name */
    currencyName: PropTypes.string.isRequired,
    /** Currency symbol */
    currencySymbol: PropTypes.string.isRequired,
    /** True for current site currency */
    isActive: PropTypes.bool
};
CurrencyMenuItem.defaultProps = {
    currencyCode: 'USD',
    currencyName: 'US Dollar',
    currencySymbol: '$',
    isActive: false
};

export default CurrencyMenuItem;
